'use client';

import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

export default function SSOCallbackPage() {
  return <AuthenticateWithRedirectCallback />;
}
